import { gql } from '@apollo/client';

export const fetchListsQuery = gql`
  query fetchLists {
    lists {
      results {
        id
        name
        listType
        creatorUserId
        updatedAt
      }
    }
  }
`;

export const fetchListsWithParamsQuery = gql`
  fragment listsPageInfo on Lists {
    info {
      limit
      offset
    }
  }
  query fetchLists($filterInfo: ListFilterInfoInput, $pagination: Pagination) {
    lists(filterInfo: $filterInfo, pagination: $pagination) {
      ...listsPageInfo
      results {
        id
        name
        listType
        creatorUserId
        updatedAt
      }
    }
  }
`;

export const fetchListDependentsQuery = gql`
  query($filterInfo: ListUsageFilterInfoInput!, $pagination: Pagination, $sort: Sort) {
    findListUsage(filterInfo: $filterInfo, pagination: $pagination, sort: $sort) {
      results {
        ... on Workflow {
          id
          name
          createdAt
          updatedAt
          creatorUserId
          updatedByUserId
          status
          enabled
          isArchived
          workflowType
        }
        ... on List {
          id
          name
          createdAt
          updatedAt
          creatorUserId
        }
        ... on Campaign {
          id
          name
          createdAt
          updatedAt
          createdBy
          updatedBy
          campaignState
          messageMedium
          templateId
        }
        __typename
      }
      info {
        count
      }
    }
  }
`;

export const fetchListTreeViewQuery = gql`
  query fetchListTreeView($folderId: Long!, $pagination: Pagination, $content: [ContentFilter!]) {
    listFolder(folderId: $folderId, pagination: $pagination, content: $content) {
      id
      name
      ancestors {
        id
        name
      }
      content {
        ... on ListSubfolder {
          id
          name
        }
        ... on List {
          id
          name
        }
      }
    }
  }
`;

export const fetchListFoldersQuery = gql`
  query fetchListFolders($listFilterInfo: ListFilterInfoInput, $pagination: Pagination, $sort: Sort, $search: String, $folderId: Long, $content: [ContentFilter!], $recursive: Boolean) {
    listFolder(
      listFilterInfo: $listFilterInfo, pagination: $pagination, sort: $sort, search: $search, folderId: $folderId, content: $content, recursive: $recursive
    ) {
      id
      name
      info {
        count
        offset
        limit
        page
      }
      ancestors {
        id
        name  
      }
      content {
        ... on ListSubfolder {
          id
          name
        }
        ... on List {
          id
          name
          listType
          creatorUserId
          updatedAt
          createdAt
          description
          size
          hasBrandAffinityQuery
          updatedByUserId
        }
      }
    }
  }
`;

export const queryListFolderDetails = gql`
  query listFolderDetails($folderId: Long!) {
    listFolderDetails(folderId: $folderId) {
      id
      name
      ancestorIds
      subfolderIds
      contentIds
    }
  }
`;

export const fetchRootListFolderQuery = gql`
  query FetchRootFolder($listFilterInfo: ListFilterInfoInput) {
    listFolder(listFilterInfo: $listFilterInfo) {
      id
    }
  }
`;
